import { memo, useState } from 'react'
import { useLdFlag } from '@renderer/chat/hooks/useLdFlag'
import { LegalAcceptanceModal } from '@renderer/components/Modal/modals/legal-acceptance-modal'
import { useAuthStatus } from '@renderer/hooks/use-auth-status'
import { useIsOnboarded } from '@renderer/hooks/useIsOnboarded'
import {
  LEGAL_CMS_FLAG,
  useFlushQueuedLegalAcceptance,
  useLegalObligations,
} from '@renderer/hooks/use-legal-obligations'

/** Blocks the panel card while an onboarded, signed-in user owes a material legal version (behind `legal-cms`). */
export const SidepanelLegalGate = memo(() => {
  const flagOn = useLdFlag<boolean>(LEGAL_CMS_FLAG, false)
  const authStatus = useAuthStatus()
  const isOnboarded = useIsOnboarded()
  const enabled = flagOn && authStatus === 'signedIn' && isOnboarded
  const obligations = useLegalObligations(enabled)
  useFlushQueuedLegalAcceptance(enabled)

  const [layer, setLayer] = useState<HTMLDivElement | null>(null)

  const pending = enabled && obligations.data?.pending === true
  if (!pending) return null
  return (
    <div ref={setLayer} className="pointer-events-none absolute inset-0 z-50">
      {layer && <LegalAcceptanceModal container={layer} />}
    </div>
  )
})
SidepanelLegalGate.displayName = 'SidepanelLegalGate'
